import React from "react";
import { Link } from "react-router-dom";
import { Carousel } from "react-bootstrap";
import MegaHeader from "./MegaHeader";
import config from "../config";
import { imageUrl } from "../utils/imagePath";
import "./Maindashboardstyle.scss";

const SliderComponent = () => {
  const img = (file) => imageUrl("main-dashboard", file);
  return (
    <>
      <MegaHeader />

      <div className="main-dashboard-page">
      <Carousel
        interval={5000}
        controls
        indicators={false}
        className="main-carousel"
        prevLabel=""
        nextLabel=""
        prevIcon={<span className="carousel-control-prev-icon" aria-hidden="true" />}
        nextIcon={<span className="carousel-control-next-icon" aria-hidden="true" />}
      >
        {/* fleet tracking */}
        <Carousel.Item className="main-carousel-item">
          <img className="d-block w-100 main-carousel-img" src={img("ftlp.jpg")} alt="Fleet tracking" />
          <Carousel.Caption className="d-none d-md-block" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between">
              <div className="text-start">
                <h5>Safe Routes, Smarter Operations</h5>
                <p>Harnessing IoT for Uninterrupted Fleet Connectivity</p>
              </div>
              <div className="text-right">
                <Link
                  to={config.routes.FTRoute}
                  className="btn btn-primary rounded-pill"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More
                </Link>
              </div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* lulusar */}
        <Carousel.Item className="main-carousel-item">
          <img className="d-block w-100 main-carousel-img" src={img("r3.png")} alt="Retail" />
          <Carousel.Caption className="d-none d-md-block" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between">
              <div className="text-start">
                <h5>Data Leading the Way in Retail</h5>
                <p>Turning insights into retail wins</p>
              </div>
              <div className="text-right">
                <Link
                  to={config.routes.Lulusar}
                  className="btn btn-primary rounded-pill"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More
                </Link>
              </div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* Gen Ai */}
        <Carousel.Item className="main-carousel-item">
          <img className="d-block w-100 main-carousel-img" src={img("GenAiBg.png")} alt="Gen AI" />
          <Carousel.Caption className="d-none d-md-block" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between">
              <div className="text-start">
                <h5>Achieving Organizational Productivity with Gen AI</h5>
                <p>Developing an AI chatbot to help reduce operational costs by 20%</p>
              </div>
              <div className="text-right">
                <Link
                  to={config.routes.GenAi}
                  className="btn btn-primary rounded-pill"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More
                </Link>
              </div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* levis */}
        <Carousel.Item className="main-carousel-item">
          <img className="d-block w-100 main-carousel-img" src={img("Jeans Group.png")} alt="Levis" />
          <Carousel.Caption className="d-none d-md-block" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between">
              <div className="text-start">
                <h5>Fast, Accurate Textile Defect Detection</h5>
                <p>Automating Quality Control for Quicker, More Precise Results in Textile Manufacturing</p>
              </div>
              <div className="text-right">
                <Link
                  to={config.routes.Levis}
                  className="btn btn-primary rounded-pill"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More
                </Link>
              </div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* Hubspot */}
        <Carousel.Item className="main-carousel-item">
          <img className="d-block w-100 main-carousel-img" src={img("emailmarketing.jpg")} alt="Hubspot" />
          <Carousel.Caption className="d-none d-md-block" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between">
              <div className="text-start">
                <h5>Emails that Convert</h5>
                <p>Boost email performance with data-driven insights</p>
              </div>
              <div className="text-right">
                <Link
                  to={config.routes.Hubspot}
                  className="btn btn-primary rounded-pill"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More
                </Link>
              </div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* LinkedIN */}
        <Carousel.Item className="main-carousel-item">
          <img className="d-block w-100 main-carousel-img" src={img("limain.png")} alt="LinkedIn" />
          <Carousel.Caption className="d-none d-md-block" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between">
              <div className="text-start">
                <h5>LinkedIn Metrics Matter</h5>
                <p>Visualize, Analyze, and Boost Your LinkedIn Marketing and Branding</p>
              </div>
              <div className="text-right">
                <Link
                  to={config.routes.LinkedInRoute}
                  className="btn btn-primary rounded-pill"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More
                </Link>
              </div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* marketing analytics */}
        <Carousel.Item className="main-carousel-item">
          <img className="d-block w-100 main-carousel-img" src={img("mganalytics.png")} alt="Marketing analytics" />
          <Carousel.Caption className="d-none d-md-block" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between">
              <div className="text-start">
                <h5>Data Dive to Digital Thrive</h5>
                <p>Transforming a data-overwhelmed website into a high-performing digital asset, boosting engagement and conversions globally</p>
              </div>
              <div className="text-right">
                <Link
                  to={config.routes.MarketingAnalytics}
                  className="btn btn-primary rounded-pill"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More
                </Link>
              </div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* DP stackoverflow */}
        <Carousel.Item className="main-carousel-item">
          <img className="d-block w-100 main-carousel-img" src={img("dpstack.png")} alt="DP Stack" />
          <Carousel.Caption className="d-none d-md-block" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between">
              <div className="text-start">
                <h5>Advancing Enterprise Collaboration with DP Intelligence</h5>
                <p>Breaking down information silos to unlock your company's collective potential</p>
              </div>
              <div className="text-right">
                <Link
                  to={config.routes.DataPilotStackOverFlow}
                  className="btn btn-primary rounded-pill"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More
                </Link>
              </div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* paid organic analytics */}
        <Carousel.Item className="main-carousel-item">
          <img className="d-block w-100 main-carousel-img" src={img("organicmedia.png")} alt="Organic media" />
          <Carousel.Caption className="d-none d-md-block" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between">
              <div className="text-start">
                <h5>Fueling Smarter Marketing with Integrated Media Insights</h5>
                <p>Unleashing the Power of Media Analytics for Smarter Business Decisions</p>
              </div>
              <div className="text-right">
                <Link
                  to={config.routes.PaidOrganicMedia}
                  className="btn btn-primary rounded-pill"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More
                </Link>
              </div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* churn prediction */}
        <Carousel.Item className="main-carousel-item">
          <img className="d-block w-100 main-carousel-img" src={img("churnmain.png")} alt="Churn" />
          <Carousel.Caption className="d-none d-md-block" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between">
              <div className="text-start">
                <h5>AI-Driven Customer Retention: Stay Ahead of Churn</h5>
                <p>Predict, Engage, and Retain: A Smarter Approach to Reducing Churn</p>
              </div>
              <div className="text-right">
                <Link
                  to={config.routes.Churn}
                  className="btn btn-primary rounded-pill"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More
                </Link>
              </div>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>

      <div className="row mt-4 px-5 main-dashboard-cards-row">
      <Link to={config.routes.OcrCaseStudy} className="col" onClick={(e) => e.stopPropagation()}>
    <div className="image-container">
        <img src={img("Group 58.png")} className="card-img-top main-dashboard-card-img" alt="OCR" />
        <div className="image-text">Optical Character Recognition</div>
    </div>
</Link>

        <Link to={config.routes.Elm} className="col" onClick={(e) => e.stopPropagation()}>
    <div className="image-container">
            <img src={img("Elmbg.png")} className="card-img-top main-dashboard-card-img" alt="ELM" />
        <div className="image-text">Vigilant Vision</div>
    </div>
</Link>

        <Link to={config.routes.PSW} className="col" onClick={(e) => e.stopPropagation()}>
          <div className="image-container">
            <img src={img("PswMain.png")} className="card-img-top main-dashboard-card-img" alt="PSW" />
            <div className="image-text">Trade Empowerment</div>
          </div>
        </Link>
      </div>
      </div>
    </>
  );
};

export default SliderComponent;
